module.exports = __webpack_public_path__ + "img/kelev_bachatzer_no.a56707fc.png";